import { Box } from "@mui/material";
import BuildNewProductCard from "./BuildNewProductCard";
import DraftProductCard from "./DraftProductCard";
import ProductCard from "./ProductCard";
import type { Product } from "./types";
import type { ProductCreationDraftRecord } from "../newProduct/draftApi";
import type { TrackedBatch } from "../batchGeneration";

interface ProductsGridViewProps {
    products: Product[];
    onOpenProduct: (product: Product) => void;
    onEditProduct: (product: Product) => void;
    onDeleteProduct: (product: Product) => void;
    onSyncProduct?: (product: Product) => void;
    onGenerateAll?: (product: Product) => void;
    onAnalyzeContext?: (product: Product) => void;
    onRetryBuild?: (product: Product) => void;
    retryingProductIds?: ReadonlySet<string>;
    retryErrorsByProductId?: ReadonlyMap<string, string>;
    onOpenBatchDetails?: () => void;
    batchesByProductId?: ReadonlyMap<string, TrackedBatch>;
    pendingBatchProductIds?: ReadonlySet<string>;
    onCreateProduct: () => void;
    drafts?: ProductCreationDraftRecord[];
    onResumeDraft?: (draft: ProductCreationDraftRecord) => void;
    onDeleteDraft?: (draft: ProductCreationDraftRecord) => void;
}

const ProductsGridView = ({
    products,
    onOpenProduct,
    onEditProduct,
    onDeleteProduct,
    onSyncProduct,
    onGenerateAll,
    onAnalyzeContext,
    onRetryBuild,
    retryingProductIds,
    retryErrorsByProductId,
    onOpenBatchDetails,
    batchesByProductId,
    pendingBatchProductIds,
    onCreateProduct,
    drafts = [],
    onResumeDraft,
    onDeleteDraft
}: ProductsGridViewProps) => (
    <Box
        sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: 1.75
        }}
    >
        <BuildNewProductCard onClick={onCreateProduct} />
        {onResumeDraft &&
            onDeleteDraft &&
            drafts.map(draft => <DraftProductCard key={draft.draft_id} draft={draft} onResume={onResumeDraft} onDelete={onDeleteDraft} />)}
        {products.map(product => (
            <ProductCard
                key={product.id}
                product={product}
                onOpen={onOpenProduct}
                onEdit={onEditProduct}
                onDelete={onDeleteProduct}
                onSync={onSyncProduct}
                onGenerateAll={onGenerateAll}
                onAnalyzeContext={onAnalyzeContext}
                onRetryBuild={onRetryBuild}
                retryPending={retryingProductIds?.has(product.id)}
                retryError={retryErrorsByProductId?.get(product.id)}
                onOpenBatchDetails={onOpenBatchDetails}
                batch={batchesByProductId?.get(product.id)}
                batchPending={pendingBatchProductIds?.has(product.id)}
            />
        ))}
    </Box>
);

export default ProductsGridView;
